import { apps } from "@/config/apps";
import { AppConfig } from "@/types/app";

const extractSubdomainFromUrl = (redirectUrl: string): string | null => {
    try {
        const url = new URL(redirectUrl);
        const hostname = url.hostname.toLowerCase();
        const parts = hostname.split('.');
        if (parts.length < 2) {
            return null;
        }
        return parts[0]; 
    } catch (error) {
        console.error('Error parsing redirect URL:', error);
        return null;
    }
};

export const getAppFromRedirectUrl = (redirectUrl: string): AppConfig | null => {
    if (!redirectUrl) {
        return null;
    }
    
    const redirectUrlLower = redirectUrl.toLowerCase();
    
    for (const app of apps) {
        if (app.link && redirectUrlLower.startsWith(app.link.toLowerCase())) {
            return app;
        }
    }
    
    // Extract subdomain and try to match
    const subdomain = extractSubdomainFromUrl(redirectUrl);
    if (!subdomain) {
        return null;
    }
    
    const appKey = subdomain.split('-')[0]; // e.g., "chopper" from "chopper-dev"
    
    // Match against app name or link
    for (const app of apps) {
        const appNameLower = app.name.toLowerCase();
        const appLinkLower = app.link?.toLowerCase() || '';
        
        // Check if app name contains the key
        if (appNameLower.includes(appKey)) {
            return app;
        }
        
        // Check if app link contains the key
        if (appLinkLower.includes(appKey)) {
            return app;
        }
        
        // Check if subdomain matches directly (for cases like "cms-dev" matching "OTT CMS")
        if (appLinkLower.includes(subdomain)) {
            return app;
        }
    }
    
    return null;
};

export const getAppNameFromUrl = (redirectUrl: string): string => {
    const app = getAppFromRedirectUrl(redirectUrl);
    if (app) {
        return app.name;
    }
    
    // Fallback to hostname
    try {
        const url = new URL(redirectUrl);
        return url.hostname;
    } catch {
        return redirectUrl;
    }
};

